module.exports = __webpack_public_path__ + "img/bg-login-page.0ca43f31.svg";